import * as React from "react";
import { cn } from "../lib/utils";
import { Collapsible } from "./collapsible";
import { SectionHeading } from "./section-heading";

interface FormSectionProps {
  title: string;
  count?: number;
  actions?: React.ReactNode;
  collapsible?: boolean;
  defaultOpen?: boolean;
  indent?: boolean;
  children: React.ReactNode;
  className?: string;
}

function FormSection({
  title,
  count,
  actions,
  collapsible = false,
  defaultOpen,
  indent = true,
  children,
  className,
}: FormSectionProps) {
  const label = count !== undefined ? `${title} (${count})` : title;

  if (collapsible) {
    return (
      <div className={className}>
        {actions ? (
          <div className="flex items-center justify-between">
            <Collapsible
              trigger={<SectionHeading size="md">{label}</SectionHeading>}
              triggerClassName="text-base"
              defaultOpen={defaultOpen}
              className="flex-1"
            >
              <div className={cn(indent && "pl-4")}>{children}</div>
            </Collapsible>
            {actions}
          </div>
        ) : (
          <Collapsible
            trigger={<SectionHeading size="md">{label}</SectionHeading>}
            triggerClassName="text-base"
            defaultOpen={defaultOpen}
          >
            <div className={cn(indent && "pl-4")}>{children}</div>
          </Collapsible>
        )}
      </div>
    );
  }

  return (
    <div className={className}>
      {actions ? (
        <div className="mb-2 flex items-center justify-between">
          <SectionHeading size="md">{label}</SectionHeading>
          {actions}
        </div>
      ) : (
        <SectionHeading size="md" className="mb-2 block">
          {label}
        </SectionHeading>
      )}
      <div className={cn(indent && "pl-4")}>{children}</div>
    </div>
  );
}

export { FormSection };
export type { FormSectionProps };
